import React from 'react';
import { FooterStyle } from 'styledcomponents/FooterStyle';

const Footer = () => {
  return (
    <FooterStyle>
      <p>Quiz av Kartika, Sofia, Joel, Linnéa & Maria</p>
    </FooterStyle>
  );
};

export default Footer;
